import styled, { css } from 'styled-components/macro';
import KeyValuePair, {
  Data as KeyValuePairValue,
} from 'components/base/KeyValuePair/KeyValuePair';
import modularScale from 'styles/helpers/modular-scale';
import PerformanceTrendLoader from 'components/utility/ContentLoader/PerformanceTrendLoader/PerformanceTrendLoader';
import getMargins from 'components/data-visualization/LineChart/helpers/getMargins';
import { IIterator } from 'types/shared';
import { Root } from 'components/data-visualization/Chart/Chart';
import Box from 'components/elements/Box';
import { ButtonWrapper } from 'components/base/Dropdown/shared/styles';

export const VisiblePeriod = styled(KeyValuePair)<IIterator>`
  ${KeyValuePairValue} {
    font-size: ${modularScale(1)};

    @media screen and (min-width: 32.5em) {
      font-size: ${modularScale(3)};
    }
  }
`;

export const VisiblePeriodWrapper = styled('dl')<any>`
  flex-grow: 1;
  margin-top: 1em;
  max-width: ${({ width }): any => width || 'auto'};

  @media screen and (max-width: 48rem) {
    order: 4;
    margin-bottom: 1.25rem;
  }

  @media screen and (min-width: 50em) {
    margin-top: 0;
  }
`;

export const Relative = styled('div')`
  position: relative;
  ${Root} {
    margin: 0.75em 0 0.25em;
  }
`;

export const StyledPerformanceTrendLoader = styled(PerformanceTrendLoader)<any>`
  position: absolute;
  ${({ hasBottomMargin }: any): any => {
    const margin = getMargins(hasBottomMargin);

    return css`
      top: ${margin.top}px;
      bottom: ${margin.bottom + 8}px;
    `;
  }}
  left: 0;
  right: 0;
  max-width: none;
  display: flex;
  align-items: center;

  > svg {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const GroupCompareWrapper = styled<any>('div')`
  display: flex;
  ${({ isSmallScreen }) =>
    isSmallScreen
      ? `
    div {
      height: 48px;
      font-size: 14px;
    }
    div:nth-of-type(2) {
      width: 100%;
      label {
        font-size: 14px;
        padding: unset;
      }
    }
  `
      : ''}

  .dropdown-sources ${ButtonWrapper} {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    border-top-right-radius: initial;
    border-bottom-right-radius: initial;
  }
  ${ButtonWrapper} {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border-top-left-radius: initial;
    border-bottom-left-radius: initial;
  }
`;

export const dataTogglePadding = ({
  noPadding,
}: {
  noPadding: boolean;
}): any => css`
  @media screen and (min-width: 48em) {
    padding-left: ${(): any => (noPadding ? '0' : '60px')};
  }
`;

export const DataToggleContainer = styled('div')<any>`
  ${dataTogglePadding}
`;

export const ShortFormRadioWrapper = styled(Box)`
  input[value='total'] + label {
    border-top-right-radius: initial;
    border-bottom-right-radius: initial;
  }
  label[data-pw='option-ugc-pgc'] {
    border-top-left-radius: initial;
    border-bottom-left-radius: initial;
  }
  display: flex;
  align-items: center;

  @media screen and (max-width: 50rem) {
    flex-direction: column-reverse;
    align-items: initial;
  }
`;

export const RadioGroupBox = styled(Box)`
  label[data-pw='option-markets'] {
    border-right: initial !important;
    border-left: initial !important;
  }
  input:hover:not(:checked) + label[data-pw='option-markets'] {
    border-right: initial;
    border-left: initial;
  }
  input:hover:not(:checked) + .last {
    box-shadow: initial;
  }
  input:hover:not(:checked) + label[data-pw='option-stations'] {
    box-shadow: initial;
  }
  input:disabled:not(:checked) + label {
    border-radius: initial;
  }
`;

export const RadioGroupWrapper = styled('div')`
  label.last {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .last input:disabled + label[data-pw='option-markets'] {
    border-top-left-radius: initial;
    border-bottom-left-radius: initial;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  label:first-of-type {
    border-top-right-radius: initial;
    border-bottom-right-radius: initial;
  }
`;
